import { useEffect, useState, } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as MainBiBclack } from "../../assets/images/MainBiBclack.svg";
import { isLogin, saveAppleSignupHint } from "../../utils";
import { ReactComponent as KakaoLoginIcon } from "../../assets/images/icon/kakaoLoginIcon.svg";
import { ReactComponent as NaverLoginIcon } from "../../assets/images/icon/naverLoginIcon.svg"
import { ReactComponent as AppleLoginIcon } from "../../assets/images/icon/appleLoginIcon.svg"
import { DevLogin, TextBtn } from "../../shared";
import { ReactComponent as Logo_S } from "../../assets/images/icon/logo.svg"
import { useMyContext } from "../../entities/context";

const Login = () => {
    const { topHeight } = useMyContext();
    const KAKAO_AUTH_URL = `kauth.kakao.com/oauth/authorize?client_id=${process.env.REACT_APP_KAKAO_LOGIN_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_KAKAO_LOGIN_REDIRECT_URI}&response_type=code&lang=ko&scope=phone_number,birthday,birthyear,gender,profile,account_email,name`;
    const NAVER_AUTH_URL = `nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${process.env.REACT_APP_NAVER_LOGIN_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_NAVER_LOGIN_REDIRECT_URI}&state=${process.env.REACT_APP_NAVER_LOGIN_STATE}&lang=ko_KR`;

    useEffect(() => {
        if (isLogin()) {
            navigate("/my")
            return;
        }
    }, [])


    const navigate = useNavigate();
    const clickKakaoLogin = () => {
        if (window.native_yoga_bridge) {
            window.native_yoga_bridge.sendMessage(JSON.stringify({
                functionName: 'kakaoLogin',
                data: {}
            }));
            return;
        }

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_yoga_bridge) {
            window.webkit.messageHandlers.native_yoga_bridge.postMessage(JSON.stringify({
                functionName: 'kakaoLogin',
                data: {}
            }))
            return;
        }

        window.location.href = "https://" + KAKAO_AUTH_URL;
    }

    const clickNaverLogin = () => {
        if (window.native_yoga_bridge) {
            window.native_yoga_bridge.sendMessage(JSON.stringify({
                functionName: 'naverLogin',
                data: {}
            }));
            return;
        }

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_yoga_bridge) {
            window.webkit.messageHandlers.native_yoga_bridge.postMessage(JSON.stringify({
                functionName: 'naverLogin',
                data: {}
            }))
            return;
        }

        navigate("//" + NAVER_AUTH_URL);
    }

    const clickAppleLogin = () => {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_yoga_bridge) {
            // Apple이 내려주는 이름/이메일은 회원가입 화면에서 그대로 채워 쓴다. (재입력을 요구하면 App Store 심사 4번 항목 위반)
            window.getAppleAuthCode = (code: string, name?: string, email?: string) => {
                saveAppleSignupHint(name, email);
                navigate("/applelogin/callback?code=" + encodeURIComponent(code))
            }
            window.webkit.messageHandlers.native_yoga_bridge.postMessage(JSON.stringify({
                functionName: 'appleLogin',
                data: {}
            }))
        }
    }

    return <>
        <div style={{ position: 'relative', height: '100vh', backgroundColor: "#FFFFFF" }}>
            <div style={{ textAlign: 'center', position: 'absolute', top: `calc(24px + ${topHeight}px)`, width: '100%' }}>
                <DevLogin />
            </div>
            <Logo_S
                width={242.29}
                height={32}
                style={{ width: '100%', marginTop: '20dvh', cursor: "pointer" }}
                fill={"var(--baseblack)"}
                onClick={() => { navigate("/") }} />
            <div style={{ textAlign: 'center', position: 'absolute', bottom: '18vh', width: '100%' }}>
                <div onClick={clickKakaoLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '0 20px 20px', paddingBlock: '14px', borderRadius: '4px', backgroundColor: '#FEE500' }}>
                    <KakaoLoginIcon />
                    <div className="sub-title/st3">
                        카카오로 시작하기
                    </div>
                </div>
                <div onClick={clickNaverLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '0 20px 20px', paddingBlock: '14px', borderRadius: '4px', backgroundColor: '#03C75A' }}>
                    <NaverLoginIcon />
                    <div className="sub-title/st3 base/white">
                        네이버로 시작하기
                    </div>
                </div>
                {(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_yoga_bridge) &&
                    <div onClick={clickAppleLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '0 20px 20px', paddingBlock: '14px', borderRadius: '4px', backgroundColor: '#090A0B' }}>
                        <AppleLoginIcon />
                        <div className="sub-title/st3 base/white">
                            Apple로 시작하기
                        </div>
                    </div>
                }
                <TextBtn onClick={() => navigate('/')} classNames={{ children: 'secondary/s800' }} style={{ paddingTop: '12px' }} icon={false} type='underline' children={'로그인 전 둘러보기'} />
            </div>
        </div>
    </>
}
export default Login;
